import { useCallback } from "react";

import type { HotelInput } from "@/lib/gql/__generated__/graphql";

import { useCustomMutation } from "@/hooks/use-graphql-client";

import { START_GUIDE_QUERY } from "@/components/features/_shared/repository/start-guide/query/schema";

import { HotelUpdate_HotelInfoSettingsPage_Mutation } from "./mutation";

export const useHotelInfoUpdateMutation = () => {
	const { mutationFunc } = useCustomMutation(HotelUpdate_HotelInfoSettingsPage_Mutation);
	const onUpdate = useCallback(
		async (input: HotelInput) => {
			return await mutationFunc({
				variables: {
					input,
				},
				refetchQueries: [
					{
						query: START_GUIDE_QUERY,
						variables: {
							hotelID: input.hotelID,
						},
					},
				],
			});
		},
		[mutationFunc],
	);

	return {
		onUpdate,
	};
};
